"use strict";
// Shared TypeScript types for the Head-to-Head feature.
Object.defineProperty(exports, "__esModule", { value: true });
